// Mocked data for the Zayka Sphere clone (frontend-only)

export const BRAND = {
  name: 'Zayka Sphere',
  tagline: 'Taste Ka Asli Global Station',
  slogan: 'Crazy Food for Crazy You!',
  phone: '+91 9369050284',
  whatsapp: 'https://wa.me/919369050284',
  email: 'ankursinha@zaykasphere.com',
  website: 'www.zaykasphere.com',
  instagram: 'https://instagram.com/zaykasphere',
  ig_handle: '@zaykasphere',
  youtube: 'https://youtube.com/@zaykasphere?si=jwQ7jmDduXjWDiPF',
  facebook: 'https://www.facebook.com/share/1JVKRvkpRa/',
  logo: '/logos/zayka-logo.png',
  banner1: 'https://customer-assets-eiarnc6j.emergentagent.net/job_4b775213-0f70-4c0d-90e5-91d72b687df9/artifacts/omxgw71l_WhatsApp%20Image%202026-07-02%20at%209.30.15%20PM.jpeg',
  banner2: 'https://customer-assets-eiarnc6j.emergentagent.net/job_4b775213-0f70-4c0d-90e5-91d72b687df9/artifacts/dwrfyki7_WhatsApp%20Image%202026-07-02%20at%209.3.15%20PM.jpeg'
};

export const IMG = {
  burger: 'https://images.unsplash.com/photo-1550547660-d9450f859349?crop=entropy&cs=srgb&fm=jpg&q=85',
  burger2: 'https://images.pexels.com/photos/15010285/pexels-photo-15010285.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  momos: 'https://images.unsplash.com/photo-1738608084602-f9543952188e?crop=entropy&cs=srgb&fm=jpg&q=85',
  momos2: 'https://images.unsplash.com/photo-1625220194771-7ebdea0b70b9?crop=entropy&cs=srgb&fm=jpg&q=85',
  pasta: 'https://images.unsplash.com/photo-1708184528301-b0dad28dded5?crop=entropy&cs=srgb&fm=jpg&q=85',
  fries: 'https://images.unsplash.com/photo-1714651620426-1ae32ca6b418?crop=entropy&cs=srgb&fm=jpg&q=85',
  interior: 'https://images.unsplash.com/photo-1667388969250-1c7220bf3f37?crop=entropy&cs=srgb&fm=jpg&q=85',
  streetfood: 'https://images.unsplash.com/photo-1552912470-ee2e96439539?crop=entropy&cs=srgb&fm=jpg&q=85',
  mocktail: 'https://images.unsplash.com/photo-1595981267035-7b04ca84a82d?crop=entropy&cs=srgb&fm=jpg&q=85',
  mocktail2: 'https://images.unsplash.com/photo-1595977514600-72cbc8376c38?crop=entropy&cs=srgb&fm=jpg&q=85',
  shake: 'https://images.unsplash.com/photo-1577805947697-89e18249d767?crop=entropy&cs=srgb&fm=jpg&q=85',
  shake2: 'https://images.pexels.com/photos/34711204/pexels-photo-34711204.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
};

export const PLATFORMS = [
  {
    name: 'Zomato',
    color: 'from-red-500 to-red-600',
    letter: 'Z',
    logo: '/logos/zomato.png',
    url: 'https://www.zomato.com/lucknow/zayka-sphere-rajajipuram'
  },
  {
    name: 'Swiggy',
    color: 'from-orange-500 to-orange-600',
    letter: 'S',
    logo: '/logos/swiggy.png',
    url: 'https://www.swiggy.com/city/lucknow/zayka-sphere-chowk-rajajipuram-rest1380339'
  },
  {
    name: 'Magicpin',
    color: 'from-purple-500 to-purple-600',
    letter: 'M',
    logo: '/logos/magicpin.png',
    url: 'https://magicpin.in/Lucknow/Rajajipuram/Restaurant/Zayka-Sphere/store/209a928'
  },
  {
    name: 'Toingit',
    color: 'from-emerald-500 to-teal-600',
    letter: 'T',
    logo: '/logos/toingit.png',
    url: 'https://www.toingit.com/menu/1380339'
  }
];

export const WHY_US = [
  { title: 'Fresh Ingredients', desc: 'Fresh ingredients selected for quality and flavour.', icon: 'Leaf' },
  { title: 'Hygienic Food', desc: 'Carefully prepared food with strong hygiene standards.', icon: 'Sparkles' },
  { title: 'Best Quality', desc: 'Consistent taste and quality across every order.', icon: 'Award' },
  { title: 'Made With Love', desc: 'Food created to make every bite memorable.', icon: 'Heart' }
];

export const BESTSELLERS = [
  { name: 'Veg Cheese Burger', price: 115, img: 'burger', desc: 'Melting cheese over a crisp veg patty.' },
  { name: 'Crispy Masala Cheese Burger', price: 130, img: 'burger2', desc: 'Masala-spiced patty loaded with cheese.' },
  { name: 'Veg Peri-Peri Momos', price: 110, img: 'momos', desc: 'Tossed in fiery peri-peri seasoning.' },
  { name: 'Paneer Chillies Momos', price: 150, img: 'momos2', desc: 'Paneer momos in bold chilli sauce.' },
  { name: 'White Sauce Pasta', price: 150, img: 'pasta', desc: 'Creamy white sauce with herbs.' },
  { name: 'Peri-Peri French Fries', price: 110, img: 'fries', desc: 'Fries dusted with peri-peri masala.' }
];

export const MENU_CATEGORIES = {
  Burgers: [
    { name: 'Veg Aloo Patty Burger', price: 100, desc: 'Classic spiced aloo patty with fresh veggies and house sauce.', img: 'burger' },
    { name: 'Veg Paneer Burger', price: 100, desc: 'Golden paneer patty layered with crunchy salad.', img: 'burger2' },
    { name: 'Veg Cheese Burger', price: 115, desc: 'Melting cheese over a crisp veg patty.', img: 'burger' },
    { name: 'Veg Paneer Burger (Cheese Sliced)', price: 125, desc: 'Paneer patty finished with a slice of cheese.', img: 'burger2' },
    { name: 'Crispy Aloo Tikki Burger', price: 110, desc: 'Extra crispy aloo tikki with tangy sauces.', img: 'burger' },
    { name: 'Crispy Paneer Burger', price: 120, desc: 'Crunchy coated paneer, soft bun, bold flavour.', img: 'burger2' },
    { name: 'Crispy Masala Cheese Burger', price: 130, desc: 'Masala-spiced patty loaded with cheese.', img: 'burger' }
  ],
  Momos: [
    { name: 'Veg Steamed Momos', price: 90, desc: 'Classic steamed momos with tangy chutney.', img: 'momos' },
    { name: 'Veg Fried Momos', price: 100, desc: 'Golden fried momos, crispy outside soft inside.', img: 'momos2' },
    { name: 'Veg Peri-Peri Momos', price: 110, desc: 'Tossed in fiery peri-peri seasoning.', img: 'momos' },
    { name: 'Veg Kurkure Momos', price: 120, desc: 'Crunchy coated momos with kurkure crust.', img: 'momos2' },
    { name: 'Paneer Steamed Momos', price: 130, desc: 'Soft paneer stuffing steamed to perfection.', img: 'momos' },
    { name: 'Paneer Chillies Momos', price: 150, desc: 'Paneer momos in bold chilli sauce.', img: 'momos2' },
    { name: 'Tandoori Momos', price: 140, desc: 'Smoky tandoori-marinated momos.', img: 'momos' }
  ],
  Pasta: [
    { name: 'Red Sauce Pasta', price: 140, desc: 'Tangy tomato sauce with herbs.', img: 'pasta' },
    { name: 'White Sauce Pasta', price: 150, desc: 'Creamy white sauce with herbs.', img: 'pasta' },
    { name: 'Mix Sauce Pasta', price: 160, desc: 'Best of both worlds, mixed sauce.', img: 'pasta' },
    { name: 'Peri-Peri Pasta', price: 160, desc: 'Fiery peri-peri kick in every bite.', img: 'pasta' }
  ],
  Fries: [
    { name: 'Classic French Fries', price: 90, desc: 'Golden crispy fries with a pinch of salt.', img: 'fries' },
    { name: 'Peri-Peri French Fries', price: 110, desc: 'Fries dusted with peri-peri masala.', img: 'fries' },
    { name: 'Cheese Loaded Fries', price: 140, desc: 'Fries drenched in melting cheese.', img: 'fries' }
  ],
  Corn: [
    { name: 'Classic Butter Corn', price: 80, desc: 'Steamed corn with butter and salt.', img: 'streetfood' },
    { name: 'Peri-Peri Corn', price: 90, desc: 'Corn tossed in peri-peri seasoning.', img: 'streetfood' },
    { name: 'Cheese Corn', price: 110, desc: 'Corn topped with melting cheese.', img: 'streetfood' }
  ],
  Maggi: [
    { name: 'Classic Masala Maggi', price: 60, desc: 'Comforting spiced masala maggi.', img: 'streetfood' },
    { name: 'Veg Loaded Maggi', price: 90, desc: 'Loaded with fresh veggies.', img: 'streetfood' },
    { name: 'Cheese Maggi', price: 110, desc: 'Cheesy indulgence in every bite.', img: 'streetfood' }
  ],
  'Pav Bhaji': [
    { name: 'Classic Pav Bhaji', price: 100, desc: 'Buttery pav with spicy bhaji.', img: 'streetfood' },
    { name: 'Cheese Pav Bhaji', price: 130, desc: 'Pav bhaji topped with cheese.', img: 'streetfood' }
  ],
  Poha: [
    { name: 'Classic Poha', price: 60, desc: 'Traditional Indori-style poha.', img: 'streetfood' },
    { name: 'Special Poha', price: 80, desc: 'Poha with sev, onion and lemon.', img: 'streetfood' }
  ],
  Mocktails: [
    { name: 'Blue Lagoon', price: 90, desc: 'Refreshing blue mocktail with citrus.', img: 'mocktail' },
    { name: 'Virgin Mojito', price: 90, desc: 'Fresh mint and lime cooler.', img: 'mocktail2' },
    { name: 'Watermelon Cooler', price: 100, desc: 'Chilled watermelon refresher.', img: 'mocktail' }
  ],
  Shakes: [
    { name: 'Chocolate Shake', price: 120, desc: 'Rich chocolate indulgence.', img: 'shake' },
    { name: 'Strawberry Shake', price: 120, desc: 'Fresh strawberry milkshake.', img: 'shake2' },
    { name: 'Oreo Shake', price: 140, desc: 'Oreo blended creamy shake.', img: 'shake' },
    { name: 'Kitkat Shake', price: 140, desc: 'Kitkat crunch in every sip.', img: 'shake2' }
  ],
  Beverages: [
    { name: 'Cold Coffee', price: 90, desc: 'Chilled creamy cold coffee.', img: 'shake' },
    { name: 'Iced Tea', price: 80, desc: 'Refreshing lemon iced tea.', img: 'mocktail' },
    { name: 'Water Bottle', price: 20, desc: 'Packaged drinking water.', img: 'mocktail2' }
  ]
};

export const TESTIMONIALS = [
  { quote: 'The Crispy Masala Cheese Burger is genuinely addictive — bold flavours and never disappoints.', name: 'Aarav S.', role: 'Verified Diner' },
  { quote: 'Momos here hit different. The peri-peri toss is 10/10 and portions feel generous.', name: 'Sneha R.', role: 'Regular Customer' },
  { quote: 'Ordered on Swiggy — arrived hot, packed well and tasted freshly made. Will re-order.', name: 'Kabir M.', role: 'Delivery Order' }
];

export const FRANCHISE_FORMATS = [
  { no: '01', title: 'Express / Cafe Format', desc: 'Compact takeaway and quick-service format.', space: '300–800 Sq. Ft.', invest: '\u20B925 Lakh – \u20B960 Lakh', fee: '\u20B95 Lakh – \u20B910 Lakh + taxes' },
  { no: '02', title: 'Standard Dine-In Restaurant', desc: 'Casual dining experience for families and groups.', space: '1,500–3,000 Sq. Ft.', invest: '\u20B970 Lakh – \u20B91.5 Crore', fee: '\u20B912 Lakh – \u20B920 Lakh + taxes' },
  { no: '03', title: 'Premium Lounge Restaurant', desc: 'Premium dining and upscale restaurant experience.', space: '3,500–6,000+ Sq. Ft.', invest: '\u20B92.5 Crore – \u20B95+ Crore', fee: '\u20B925 Lakh – \u20B940+ Lakh + taxes' }
];

export const FRANCHISE_SUPPORT = [
  { title: 'Brand Usage', desc: 'Use Zayka Sphere brand identity, systems and approved marketing assets.', icon: 'BadgeCheck' },
  { title: 'Training', desc: 'Comprehensive training for franchise owners and staff.', icon: 'GraduationCap' },
  { title: 'Marketing Support', desc: 'Brand marketing, local campaigns and promotional support.', icon: 'Megaphone' },
  { title: 'Supply Chain', desc: 'Support with approved ingredients, materials and operations.', icon: 'Truck' },
  { title: 'Operational Support', desc: 'Guidance for setup, operations, quality and brand standards.', icon: 'Settings' },
  { title: 'Technology', desc: 'POS, technology and digital systems where applicable.', icon: 'MonitorSmartphone' },
  { title: 'Menu Innovation', desc: 'Continuous product development and menu innovation.', icon: 'ChefHat' },
  { title: 'Ongoing Support', desc: 'Ongoing guidance to help franchise partners operate and grow.', icon: 'LifeBuoy' }
];

export const PROCESS_STEPS = [
  { no: '01', title: 'Submit Enquiry', desc: 'Share your details and preferred market through the enquiry form.' },
  { no: '02', title: 'Initial Discussion', desc: 'Our franchise team connects to understand your goals and background.' },
  { no: '03', title: 'Market & Location Evaluation', desc: 'We review the territory, format fit and site potential together.' },
  { no: '04', title: 'Franchise Approval & Agreement', desc: 'Commercial terms are finalised and documented in the agreement.' },
  { no: '05', title: 'Training, Setup & Launch', desc: 'Setup support, team training and a guided brand launch.' }
];

export const MARKETS = ['India', 'Malaysia', 'China', 'Japan', 'Saudi Arabia', 'Dubai / UAE', 'Europe', 'USA / America'];

export const GLOBAL_INFO = [
  { label: 'International Master Franchise Fee', value: 'USD 250,000 – USD 1,000,000+' },
  { label: 'Per-Unit Setup Cost', value: 'USD 300,000 – USD 600,000 per unit' },
  { label: 'Ongoing Royalty', value: '5% – 8% of gross sales' },
  { label: 'Marketing Contribution', value: '2% – 4% of gross sales' }
];

export const MASTER_BENEFITS = [
  { title: 'Exclusive Territory', desc: 'Rights to operate and develop the brand within an agreed territory.', icon: 'Map' },
  { title: 'Brand Usage', desc: 'Use of approved Zayka Sphere branding and IP.', icon: 'BadgeCheck' },
  { title: 'Sub-Franchising', desc: 'Recruit and manage unit franchisees within territory.', icon: 'Users' },
  { title: 'Training', desc: 'Training and operational guidance.', icon: 'GraduationCap' },
  { title: 'Marketing', desc: 'Regional marketing and advertising support.', icon: 'Megaphone' },
  { title: 'Supply Chain', desc: 'Support for approved sourcing and supply systems.', icon: 'Truck' },
  { title: 'Quality Control', desc: 'Brand standards, operational consistency and audits.', icon: 'ShieldCheck' },
  { title: 'Reporting', desc: 'Structured reporting and performance management.', icon: 'BarChart3' }
];
